import io from 'socket.io-client';
import {UAParser} from "ua-parser-js"; 
 import axios from "axios";

// Separate sockets for user and admin (connected to different namespaces)
const usersocket = io(`${process.env.VUE_APP_BASE_URL}notifications`);  // User namespace
const adminsocket = io(`${process.env.VUE_APP_BASE_URL}admin-notifications`);  // Admin namespace

export default {
  // User joining their specific room
  joinRoom(userId) {
    usersocket.emit('joinRoom', userId);
    console.log("User Join the Room: ", userId);
  },

  // Listen for user-specific notifications
  onReceiveUserNotification(callback) {
    usersocket.on('newNotification', (notification) => {
      console.log("Notification User received: ", notification);
      callback(notification);
    });
    console.log("onReceiveUserNotification Called ..... ");
  },

  // Admin joining the admin room
  joinAdminRoom() {
    adminsocket.emit('joinAdminRoom'); // Admin-specific room (no need for 'admin' string)
    console.log("Admin Join the Room");
  },

  // Listen for admin-specific notifications
  onReceiveAdminNotification(callback) {
    console.log("onReceiveAdminNotification Called ..... ");
    adminsocket.on('newAdminNotification', (notification) => {
      // console.log("Notification received: ", notification);
      callback(notification);
    });
  },

  // Global function to get full device information and location 
  // getDeviceInfoAndLocation() {
  //   return new Promise((resolve, reject) => {
  //     // Get device information from the browser
  //     const userAgent = navigator.userAgent; // Browser and OS information
  //     const platform = this.getPlatformFromUserAgent(userAgent);  // Extract platform from userAgent
  //     const language = navigator.language;   // Browser language (e.g., 'en-US')

  //     // Get the device location using the geolocation API
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           const location = {
  //             latitude: position.coords.latitude,
  //             longitude: position.coords.longitude,
  //           };

  //           resolve({
  //             deviceInfo: {
  //               userAgent: userAgent,
  //               platform: platform,
  //               language: language,
  //             },
  //             deviceLocation: location,
  //           });
  //         },
  //         (error) => {
  //           // If geolocation fails, resolve with empty location object
  //           resolve({
  //             deviceInfo: {
  //               userAgent: userAgent,
  //               platform: platform,
  //               language: language,
  //             },
  //             deviceLocation: { latitude: null, longitude: null },
  //           });
  //         }
  //       );
  //     } else {
  //       // If geolocation is not available, resolve with empty location object
  //       resolve({
  //         deviceInfo: {
  //           userAgent: userAgent,
  //           platform: platform,
  //           language: language,
  //         },
  //         deviceLocation: { latitude: null, longitude: null },
  //       });
  //     }
  //   });
  // },
 
 async getDeviceInfoAndLocation() {
  return new Promise((resolve) => {
    const parser = new UAParser();
    const result = parser.getResult();

    const platform = result.os.name || "Unknown";
    const browser = result.browser.name || "Unknown";
    const language = navigator.language || "Unknown";

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            const geoRes = await axios.get(
              "https://maps.googleapis.com/maps/api/geocode/json",
              {
                params: {
                  latlng: `${latitude},${longitude}`,
                  key: "AIzaSyA2Ko83u6w8xAzgsmoloN_je3OEtsWjzZw",
                },
              }
            );
            console.log("Google Geo Response:", geoRes.data); // ADD HERE

         const components =
  geoRes.data.results?.flatMap(
    (result) => result.address_components || []
  ) || [];

            const getComponent = (type, short = false) => {
              const comp = components.find((c) =>
                c.types.includes(type)
              );

              return comp
                ? short
                  ? comp.short_name
                  : comp.long_name
                : "";
            };

            const countryCode = getComponent("country", true);

            resolve({
              deviceInfo: {
                platform,
                browser,
                language,
              },

              deviceLocation: {
                latitude,
                longitude,

                countryCode,
                country: getComponent("country"),
                countryFlag: `https://flagcdn.com/${countryCode.toLowerCase()}.svg`,
                region: getComponent("administrative_area_level_1"),

                city:
                  getComponent("locality") ||
                  getComponent("administrative_area_level_2")
              }
            });

          } catch (err) {
            console.error("Geo lookup failed:", err);

            resolve({
              deviceInfo: {
                platform,
                browser,
                language,
              },

              deviceLocation: {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              }
            });
          }
        },

        (error) => {
          resolve({
            deviceInfo: {
              platform,
              browser,
              language,
            },

            deviceLocation: {
              latitude: null,
              longitude: null,
            },

            error
          });
        }
      );
    } else {
      resolve({
        deviceInfo: {
          platform,
          browser,
          language,
        },

        deviceLocation: {
          latitude: null,
          longitude: null,
        }
      });
    }
  });
},

  // Helper function to extract platform info from userAgent
  // getPlatformFromUserAgent(userAgent) {
  //   // Example: We will match common OS types
  //   if (userAgent.indexOf('Win') !== -1) return 'Windows';
  //   if (userAgent.indexOf('Mac') !== -1) return 'Mac OS';
  //   if (userAgent.indexOf('Linux') !== -1) return 'Linux';
  //   if (userAgent.indexOf('Android') !== -1) return 'Android';
  //   if (userAgent.indexOf('iOS') !== -1 || userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1) {
  //     return 'iOS';
  //   }
  //   return 'Unknown';  // Default platform if none match
  // }

};
